module.exports = "assets/fonts/DMSans-Regular.woff";